/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Legs4(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Legs4.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Legs4.geometry}
        position={[-22.18, 38.38, 0]}
      >
        <meshPhysicalMaterial
          color={colorArr[5]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Legs4.glb')
